import { render, staticRenderFns } from "./DragTable.vue?vue&type=template&id=2054f79f&"
import script from "./DragTable.vue?vue&type=script&lang=js&"
export * from "./DragTable.vue?vue&type=script&lang=js&"
import style0 from "./DragTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports